/*
 * @Author: huangying
 * @Date: 2021-12-30 13:53:21
 * @Last Modified by: huxianyong
 * @Last Modified time: 2023-06-06 14:47:52
 */

import { renderFirstRow, renderSecRow } from "./price_page";
import UserPage from "./user_page";
import companyPage from './company_page'

export default function initPage() {
  const user_page = document.querySelector(".user_page");
  const company_page = document.querySelector(".company_page");
  // 客户案例
  user_page.innerHTML = UserPage();
  // 公司介绍
  company_page.innerHTML = companyPage();
  const trDom = document.querySelector(".first_tr");
  trDom.innerHTML = renderFirstRow();
  trDom.innerHTML += renderSecRow();
  const copyNumberId = document.getElementById("copyNumber");
  if (window.location.hostname.includes("neurongenius")) {
    copyNumberId.innerHTML = "3";
  }
}
